export default "__VITE_ASSET__OGVHBRfz__"